export const isSalesExtensionPresent = (): boolean => {
    return document.querySelector('[id^="sw-si-extension"]') !== null;
};
